import React from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import { Wrapper } from "./style"
import Boton from "../../botonFormulario"
const Formulario = props => {
  const requiredText = "Es requerido este campo"
  const formik = useFormik({
    initialValues: {
      name: "",
      telefono: "",
      empresa: "",
      email: "",
      codigo: "",
      mensaje: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(3, "Tiene que tener al menos 3 letras")
        .required(requiredText),
      telefono: Yup.string()
        .required(requiredText)
        .matches(/^[0-9]+$/, "Tiene que ser solo digitos")
        .min(9, "Tiene que ser de 9 digitos el número de teléfono")
        .max(9, "Tiene que ser de 9 digitos el número de teléfono"),
      empresa: Yup.string().required(requiredText),
      email: Yup.string()
        .email("Dirección de correo electrónico inválida")
        .required(requiredText),
      codigo: Yup.string().required(requiredText),
      mensaje: Yup.string().required(requiredText),
    }),
    onSubmit: values => {
      alert(JSON.stringify(values, null, 2))
    },
  })
  return (
    <div className="container">
      <Wrapper>
        <img src={props.img} alt="imagen de formulario" />
        <div className="formulario">
          <h2>{props.title || "undefined"}</h2>
          <form action="" method="post">
            <label htmlFor="Nombres">Nombres y Apellidos</label>
            <input id="name" type="text" {...formik.getFieldProps("name")} />
            {formik.touched.name && formik.errors.name ? (
              <div className="errorForm">{formik.errors.name}</div>
            ) : null}
            <label htmlFor="tipo">Tipo</label>
            <select name="tipo" required>
              <option value="Garantia">Garantia</option>
              <option value="Garantia">Garantia</option>
              <option value="Garantia">Garantia</option>
            </select>
            <label htmlFor="telefono">Tel&eacute;fono</label>
            <input
              id="telefono"
              type="text"
              {...formik.getFieldProps("telefono")}
            />
            {formik.touched.telefono && formik.errors.telefono ? (
              <div className="errorForm">{formik.errors.telefono}</div>
            ) : null}
            <label htmlFor="empresa">Empresa</label>
            <input
              id="empresa"
              type="text"
              {...formik.getFieldProps("empresa")}
            />
            {formik.touched.empresa && formik.errors.empresa ? (
              <div className="errorForm">{formik.errors.empresa}</div>
            ) : null}
            <label htmlFor="email">Email</label>
            <input id="email" type="email" {...formik.getFieldProps("email")} />
            {formik.touched.email && formik.errors.email ? (
              <div className="errorForm">{formik.errors.email}</div>
            ) : null}
            <label htmlFor="codigo">C&oacute;digo de Vehículo Intramet</label>
            <input
              id="codigo"
              type="text"
              {...formik.getFieldProps("codigo")}
            />
            {formik.touched.codigo && formik.errors.codigo ? (
              <div className="errorForm">{formik.errors.codigo}</div>
            ) : null}
            <label htmlFor="mensaje">Mensaje</label>
            <textarea
              name="mensaje"
              id="mensaje"
              cols="30"
              rows="10"
              {...formik.getFieldProps("mensaje")}
            ></textarea>
            {formik.touched.mensaje && formik.errors.mensaje ? (
              <div className="errorForm">{formik.errors.mensaje}</div>
            ) : null}
            <div className="buttons">
              <Boton>CORREO</Boton>
              <Boton
                type="a"
                url="https://api.whatsapp.com/send?phone=51958888888&text=Hola%20Intramet%20me%20interesan%20tus%20servicios"
              >
                WHATSAPP
              </Boton>
            </div>
          </form>
        </div>
      </Wrapper>
    </div>
  )
}
export default Formulario
